import posthog from "posthog-js";

/**
 * Liste exhaustive des events metier trackes dans PostHog.
 * Source : CLAUDE.md > Conformite & Securite > Events analytics.
 * Toute nouvelle capture doit ajouter son nom ici pour beneficier de l'auto-complete typee.
 */
export type AnalyticsEventName =
  | "created_search"
  | "import_completed"
  | "contact_validated"
  | "contact_enrolled"
  | "heat_score_updated"
  | "campaign_started"
  | "message_sent"
  | "message_received"
  | "ai_intervention_triggered"
  | "pilot_mode_changed"
  | "optout_triggered"
  | "rdv_set"
  | "moved_stage"
  | "media_uploaded"
  | "contact_document_uploaded"
  | "sharelink_created"
  | "data_exported"
  | "account_deleted"
  | "sticky_event_tapped"
  | "voice_note_processed"
  | "push_action_clicked"
  | "briefing_opened"
  | "juliette_voice_played";

/**
 * Envoie un event custom a PostHog.
 * - Silencieux si PostHog n'est pas initialise (VITE_POSTHOG_KEY absente).
 * - Ne bloque jamais l'UI : toute erreur est avalee (analytics != chemin critique).
 * - Ne fait rien cote serveur / SSR.
 */
export function trackEvent(
  name: AnalyticsEventName,
  props?: Record<string, unknown>
): void {
  if (typeof window === "undefined") return;
  try {
    posthog.capture(name, props);
  } catch {
    // Silencieux : analytics ne doit jamais casser l'experience utilisateur.
  }
}
